(function () {
    'use strict';

    angular
        .module(app.modules.scoring.name)
        .filter('wager', wagerFilter);

    wagerFilter.$inject = [];
    function wagerFilter() {
        return function (value) {
            var result = Math.abs(parseFloat(value));
            return !isNaN(result) ? result.toFixed(2) : '';
        }
    }
})();